import React from 'react'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as orderCallActions from 'app/actions/order_call_actions';

class Footer extends React.Component {
  openCallOrderWindow(e) {
    e.preventDefault();
    this.props.orderCallActions.openWindow();
  }

  render() {
    return (
      <footer className="footer">
        <div className="base-width clearfix">
          <div className="mobile-show">
            <div className='header-navigation-wrapper'>
              <ul className='header-navigation'>
                <li className='nav-item item-3'>
                  <a href='https://dveriargus.com' target="_blank">Основной сайт</a>
                </li>
                <li className='nav-item item-1'>
                  <a href='http://dveriargus.com/contacts/' target="_blank">Магазины</a>
                </li>
              </ul>
              <ul className='header-navigation'>
                <li className='nav-item item-4'>
                  <a href='https://dveriargus.com/vhodnye-dveri/dveri_v_nalichii/' target="_blank">Двери в наличии</a>
                </li>
                <li className='nav-item item-2'>
                  <a href='http://dveriargus.com/dealers/' target="_blank">Дилерам</a>
                </li>
              </ul>
            </div>

            <div className="phone-">
              8 (831) 216-00-06
            </div>
            <a className="button button-red" href="#" onClick={this.openCallOrderWindow.bind(this)}>Заказать звонок</a>
          </div>
          <div className="right-">
            <a className="delivery-link" href='http://dveriargus.com/delivery/' target='_blank'> Доставка и оплата</a>
            <div className="studio-col">Сайт сделан
              <a href='http://adwant.ru' target='_blank'> в студии «Adwant»</a>
            </div>
          </div>
          <div className="left-">
            <p className="copyrights-">
              © 2006-2020 ООО «Мастер на все руки» — Официальный представитель завода «Аргус»
              в Нижнем Новгороде и Нижегородской области.
            </p>
          </div>
        </div>
      </footer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state: state.orderCall,
  }
};

const mapDispatch = (dispatch) => {
  return {
    orderCallActions: bindActionCreators(orderCallActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(Footer);



// WEBPACK FOOTER //
// ./app/javascript/app/components/footer/index.jsx